import React from 'react'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'
import { useAuth0 } from 'shared/utils/auth0'

const LoginWrapper = styled.div`
  font-family: 'Gilroy-Regular', -apple-system, BlinkMacSystemFont, Roboto, Helvetica, sans-serif !important;
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: row; 
  background-color: rgb(82, 82, 91);
`

const LoginSection = styled.section`
  position: relative;
  flex: ${props => props.isSignUpOpen ? '1' : '0 0 400px'};
  justify-content: center;
  align-items: center;
  height: 100vh;
  background: rgb(40, 40, 46);
  border-right: 1px solid rgba(28,28,33,1);
  transition: all .3s ease;
  z-index: 1;
`

const ContentSection = styled.section`
  position: relative; 
  background: #ec3192 url(${props => props.backgroundImage}) bottom center/cover no-repeat;
  display: flex;
  flex: 1 1 auto;
  justify-content: center;
  align-items: center;
  align-content: center;
  height: 100vh;
  background-color: rgb(82, 82, 91);
  transition: all .3s ease;
`

const PromoSection = styled.section`
  color: rgba(255,255,255, 0.65);
  text-align: center;
  h1 {
    margin: 16px 0 8px 0;
    font-family: 'Gilroy-SemiBold', -apple-system, BlinkMacSystemFont, Roboto, Helvetica, sans-serif !important;
    color: #FFF;
    font-size: 18px;
    line-height: 24px;
  }
  p {
    margin: 0 0 0 0;
    font-size: 13px;
    line-height: 24px;
  }
  a {
    margin: 16px 0 0 0;
    display: inline-block;
    padding: 4px 8px;
    border: 1px solid rgba(255, 255, 255, 0.7) !important;
    border-radius: 3px !important;
  }
`

const LoginWindow = ({ children }) => {
  const {
    isAuthenticated,
    loading,
    isSignInOpen,
    isSignUpOpen
  } = useAuth0()

  if(!isAuthenticated && !loading) {
    return (
      <LoginWrapper>
        <LoginSection
          id="login-window"
          isSignUpOpen={isSignUpOpen}
        >
          {children}
        </LoginSection>

        {
          isSignInOpen && (
            <ContentSection backgroundImage="https://flow.ai/assets/images/dashboard/login-content-bg.svg">
              <PromoSection>
                <img alt="image" src="https://flow.ai/assets/images/dashboard/enterprise.svg" />
                <h1>Flow.ai Enterprise Plan</h1>
                <p>The conversation AI collaboration platform for larger teams</p>
                <p>Unlimited team members. Unlimited projects. Unlimited capabilities.</p>
                <a href="mailto:sales+enterprise@flow.ai" target="_blank" rel="noopener noreferrer">Schedule a demo</a>
              </PromoSection>
            </ContentSection>
          )
        }
      </LoginWrapper>
    )
  }

  return null
}
LoginWindow.propTypes = {
  children: PropTypes.any
}

export default LoginWindow

